import { render, staticRenderFns } from "./LunchRegistrationList.vue?vue&type=template&id=0584a09e&scoped=true"
import script from "./LunchRegistrationList.vue?vue&type=script&lang=js"
export * from "./LunchRegistrationList.vue?vue&type=script&lang=js"
import style0 from "./LunchRegistrationList.vue?vue&type=style&index=0&id=0584a09e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0584a09e",
  null
  
)

export default component.exports